/**
 * Report IDs which are well know IDs.
 */
export class ReportConstants {
  /** Labor Cost Report ID */
  public static readonly employeeLaborReportID: string =
    '45872321-0C37-4214-B5AC-15037E7CE20B';

  /** Employee Labor Summary Report ID */
  public static readonly employeeLaborReportForEmployeeID: string =
    '823781EF-BC63-4EB4-8AAF-6A635FD8C564';

  /** Facility Manpower Report ID */
  public static readonly facilityManpowerReportID: string =
    '9E941900-DADD-4577-9D4C-485371D9DEF8';

  /** Company Weekly Timesheet Report ID (Time Manager one-click weekly report) */
  public static readonly companyWeeklyTimesheetReportID: string =
    '834E6322-0D82-4B84-8763-EA5ECD505C7B';

  /** Job Initiation Sheet (US 37640): Power BI paginated, live from Viewpoint by company + job */
  public static readonly jobInitiationSheetReportID: string =
    '5AEA37ED-5AA8-4F76-AB96-7654847710E3';
}
